// web_components/wcConsentModal/wcConsentModal_Renderer.ts

/**
 * Generates the HTML for the wc-consent-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(instanceId: string): string {
	return `
        <div id="${instanceId}" class="wc-consent-modal modal-active modal-transition" role="dialog" aria-labelledby="consentTitle" aria-describedby="consentDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
            <div class="wc-modal__dialog">
                <h2 class="wc-consent-modal__title">Our website uses cookies</h2>
                <p class="wc-consent-modal__description">${window.serverData.cookiesNoticeCopy}</p>
                <button id="wc-consent-modal__acceptCookies">${window.serverData.cookiesBannerAcceptBtnCopy}</button>
                <button id="wc-consent-modal__rejectCookies">${window.serverData.cookiesBannerRejectBtnCopy}</button>
                <button id="wc-consent-modal__manageCookies">${window.serverData.cookiesBannerManageBtnCopy}</button>
            </div>
        </div>
    `;
}
